/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  FC,
  useState,
  useEffect,
  forwardRef,
  useRef,
} from 'react';

import {useIntl} from 'react-intl';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import QRCode from "react-qr-code"
import { Modal } from "react-bootstrap";
import ReactLoading from 'react-loading';
import { connect } from "react-redux";
import Lottie from "lottie-react";
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-number-input';
import VerificationInput from "react-verification-input";

import {
  KTSVG,
  toAbsoluteUrl
} from '../../../_metronic/helpers';
import {PageTitle} from '../../../_metronic/layout/core';
import {Dropdown1} from '../../../_metronic/partials';

import useCountDown from "../../hooks/useCountDown";

import {
  requestCodePhoneVerification,
  validatePhone,
  verifyLogged,
  recaptcha,
} from '../../services/auth';

import verifyPhoneAnimation from '../../../_metronic/assets/animations/verifyPhone.json';

const VerifyPhone = ({isOpen}) => {
  const { auth } = useSelector((state : any) => ({
    auth: state.auth,
  }), shallowEqual);

  const intl = useIntl();
  const location :any = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [time, reset] = useCountDown(30);

  const lottieRef = useRef<any>();

  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [confirm, setConfirm] = useState(null);
  const [error, setError] = useState('');

  const resendVerification = () => {
    // recaptcha('recaptcha-container').then((value: any) =>
      fetchRequestCodePhoneVerification()
    // );
  }

  const requestValidatePhone = () => {
    dispatch<any>(validatePhone(confirm, code)).then((value) => {
      reset();
      close();

      dispatch<any>(verifyLogged(navigate, location));
    }).catch((error) => {
      setError(error);
    });
  }

  const fetchRequestCodePhoneVerification = () => {
    dispatch<any>(requestCodePhoneVerification(phone)).then((confirmation) => {
      setConfirm(confirmation);
      reset();
    }).catch((error) => {
      setError(error);
    });
  }

  const close = () => {
    setOpen(false);
    setConfirm(null);
    setPhone('');

    navigate(-1);
  }

  useEffect(() => {
    if (code.length == 6) {
      requestValidatePhone();
    }
  }, [code]);

  useEffect(() => {
    if (open) {
      recaptcha('recaptcha-container');

      lottieRef.current?.setSpeed(0.8);
      lottieRef.current?.playSegments([0, 110]);
    }
  }, [open]);

  useEffect(() => {
    if (isOpen) {
      setOpen(true);
    } else {
      close();
    }
  }, [isOpen]);

  const formik = useFormik<any>({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: (values) => {
      if (!confirm) {
        fetchRequestCodePhoneVerification();
      } else {
        requestValidatePhone();
      }
    },
  })

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open}
        dialogClassName="custom-modal mw-600px"
        onHide={() => close()}
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          {/*<Modal.Title id="example-modal-sizes-title-lg" className="py-7 d-flex justify-content-between">

          </Modal.Title>*/}

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center">
            <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10">
              <div className="w-md-400px">
                <div className="text-center mb-11">
                  <Lottie
                    animationData={verifyPhoneAnimation}
                    style={{
                      height: 250,
                    }}
                    autoPlay={false}
                    loop={false}
                    lottieRef={lottieRef}
                  />
                  <h1 className="text-dark fw-bolder mb-3 mt-3">Valide seu telefone</h1>
                  <div className="text-gray-500 fw-semibold fs-6">Valide seu telefone por sms, fique despreocupado que não compartilhamos seus dados e não enviamos spam :)</div>
                </div>

                {error && error != '' && <div className="alert bg-light-primary d-flex flex-column flex-sm-row p-5 mb-10">
                  <div className="d-flex flex-column text-primary pe-0 pe-sm-10">
                    {/*<h5 className="mb-1">Algo deu errado</h5>*/}
                    <span className="text-white fs-3 mt-2">{error}</span>
                  </div>
                  <button
                    type="button"
                    className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                    onClick={() => setError('')}
                  >
                    <span className="svg-icon svg-icon-1 svg-icon-primary">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
                      </svg>
                    </span>
                  </button>
                </div>}

                <form
                  className='form form-label-right'
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id='kt_login_signin_form'
                >
                  {!confirm && <div className="fv-row mb-8">
                    <PhoneInput
                      defaultCountry="BR"
                      international
                      countryCallingCodeEditable={false}
                      withCountryCallingCode
                      numberInputProps={{ className: "form-control bg-transparent" }}
                      value={phone}
                      onChange={(value?: any) => setPhone(value)}
                    />
                  </div>}

                  {confirm && <div className="fv-row mb-8 d-flex">
                    <VerificationInput
                      classNames={{
                        container: "flex-root d-flex",
                        character: "character",
                        characterInactive: "character--inactive",
                        characterSelected: "character--selected",
                      }}
                      onChange={setCode}
                    />
                  </div>}

                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      id="submit-sms"
                      disabled={!phone || auth.actionLoading}
                    >
                      {!auth.actionLoading && <span className="indicator-label">
                        {!confirm && `ENVIAR SMS`}
                        {confirm && `VALIDAR CÓDIGO`}
                      </span>}

                      {auth.actionLoading && <span className="indicator-label">
                        Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>}
                    </button>
                  </div>
                </form>

                {confirm && <div className="text-gray-500 text-center fw-semibold fs-6">
                  {time > 0 && <span className="link-primary">Reenviar em {time}s</span>}
                  {time == 0 && <span onClick={() => resendVerification()} className="link-primary cursor-pointer">Reenviar código</span>}
                </div>}
              </div>
            </div>
          </div>
        </Modal.Body>
        <div id="recaptcha-container"></div>
      </Modal>
    </>
  )
}

export default VerifyPhone;
